export class TestService {
	constructor() {
		console.log("TestService initialized");
	}
}
